import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import FormCad from '../../../../components/auth/transferenciasestado/form_cad'


function CadastrarTransferenciaScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Transferência Estadual" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarTransferenciaScreen;